// extracted by mini-css-extract-plugin
export default {"main":"Main_main__c4Y0c","main__hero--title":"Main_main__hero--title__UtrhU"};